export default "__VITE_ASSET__1fc8a967__"